/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Refer_FriendInputs */

const en_dialog_refer_friend = /** @type {(inputs: Dialog_Refer_FriendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer a friend`)
};

const es_dialog_refer_friend = /** @type {(inputs: Dialog_Refer_FriendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomienda a un amigo`)
};

/**
* | output |
* | --- |
* | "Refer a friend" |
*
* @param {Dialog_Refer_FriendInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_refer_friend = /** @type {((inputs?: Dialog_Refer_FriendInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Refer_FriendInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_refer_friend(inputs)
	return en_dialog_refer_friend(inputs)
});